export default __webpack_public_path__ + "static/media/realm.d102563e.svg";